import * as React from "react";
import { styled } from "@mui/system";
import MUITableContainer, {
  TableContainerProps,
} from "@mui/material/TableContainer";

export const TableContainer = styled(
  (props: TableContainerProps) => <MUITableContainer {...props} />,
  {
    name: "TableContainer",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  "&.MuiTableContainer-root": {
    margin: 0,
    boxShadow: "none",
  },
}));
